export default __webpack_public_path__ + "static/media/halloween-icon-11.c06615d4.svg";